import { render, staticRenderFns } from "./apneaHebrew.vue?vue&type=template&id=735cc84e&scoped=true&"
import script from "./apneaHebrew.vue?vue&type=script&lang=js&"
export * from "./apneaHebrew.vue?vue&type=script&lang=js&"
import style0 from "./apneaHebrew.vue?vue&type=style&index=0&id=735cc84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735cc84e",
  null
  
)

export default component.exports